export default "__VITE_ASSET__CvHJgc_o__"